import { BetBuilderMarket, BetBuilderMultipleGroup, BetBuilderStatType, BetTypeGroup, MarketType } from '@/interface/enum';

interface BetBuilderMarketMapping {
    fullTime: MarketType;
    firstHalf: MarketType;
}

const BetBuilderMarketTypeToMarketTypeMapping: Partial<Record<BetBuilderMarket, BetBuilderMarketMapping>> = {
    [BetBuilderMarket.Set1x2]: {
        fullTime: MarketType._1X2,
        firstHalf: MarketType.FH_1X2,
    },
    [BetBuilderMarket.SetDoubleChance]: {
        fullTime: MarketType.DoubleChance,
        firstHalf: MarketType.DoubleChance,
    },
    [BetBuilderMarket.SetTotalGoalsOverUnder]: {
        fullTime: MarketType.OverUnder,
        firstHalf: MarketType.FH_OverUnder,
    },
    [BetBuilderMarket.SetTotalGoalsOddEven]: {
        fullTime: MarketType.OddEven,
        firstHalf: MarketType.FH_OddEven,
    },
    [BetBuilderMarket.SetCorrectScore]: {
        fullTime: MarketType.CorrectScore,
        firstHalf: MarketType.FH_CorrectScore,
    },
    [BetBuilderMarket.SetHandicap]: {
        fullTime: MarketType.Handicap,
        firstHalf: MarketType.FH_Handicap,
    },
    [BetBuilderMarket.SetExactNumberGoals]: {
        fullTime: MarketType.TotalGoal,
        firstHalf: MarketType.TotalGoal,
    },
    [BetBuilderMarket.SetTotalCornersHandicap]: {
        fullTime: MarketType.Handicap,
        firstHalf: MarketType.FH_Handicap,
    },
    [BetBuilderMarket.SetTotalCornersOverUnder]: {
        fullTime: MarketType.OverUnder,
        firstHalf: MarketType.FH_OverUnder,
    },
    [BetBuilderMarket.SetTotalCornersOddEven]: {
        fullTime: MarketType.OddEven,
        firstHalf: MarketType.FH_OddEven,
    },
    [BetBuilderMarket.SetTotalCorners1x2]: {
        fullTime: MarketType._1X2,
        firstHalf: MarketType.FH_1X2,
    },
};

const marketTypeToBetBuilderMarketTypeMapping: Partial<Record<MarketType, BetBuilderMarket>> = {
    [MarketType._1X2]: BetBuilderMarket.Set1x2,
    [MarketType.FH_1X2]: BetBuilderMarket.Set1x2,
    [MarketType.DoubleChance]: BetBuilderMarket.SetDoubleChance,
    [MarketType.OverUnder]: BetBuilderMarket.SetTotalGoalsOverUnder,
    [MarketType.FH_OverUnder]: BetBuilderMarket.SetTotalGoalsOverUnder,
    [MarketType.OddEven]: BetBuilderMarket.SetTotalGoalsOddEven,
    [MarketType.FH_OddEven]: BetBuilderMarket.SetTotalGoalsOddEven,
    [MarketType.CorrectScore]: BetBuilderMarket.SetCorrectScore,
    [MarketType.FH_CorrectScore]: BetBuilderMarket.SetCorrectScore,
    [MarketType.Handicap]: BetBuilderMarket.SetHandicap,
    [MarketType.FH_Handicap]: BetBuilderMarket.SetHandicap,
};

const firstHalfStatTypes = new Set<BetBuilderStatType>([
    BetBuilderStatType.FirstHalf,
    BetBuilderStatType.FirstHalfCorners,
]);

const firstHalfMarketTypes = new Set([
    MarketType.FH_1X2,
    MarketType.FH_Handicap,
    MarketType.FH_OverUnder,
    MarketType.FH_OddEven,
    MarketType.FH_CorrectScore,
    MarketType.FH_LiveScore,
]);

const BetBuilderMultipleGroupToBetTypeGroupMapping: Record<BetBuilderMultipleGroup, BetTypeGroup> = {
    [BetBuilderMultipleGroup.TotalCorner]: BetTypeGroup.Soccer_TotalCorner,
};

export function betBuilderMultipleGroupToBetTypeGroup(multipleGroup: BetBuilderMultipleGroup): BetTypeGroup {
    return BetBuilderMultipleGroupToBetTypeGroupMapping[multipleGroup];
}

export function betBuilderToMarketType(
    betBuilderMarketType: BetBuilderMarket,
    statType: BetBuilderStatType,
): MarketType | undefined {
    const mapping = BetBuilderMarketTypeToMarketTypeMapping[betBuilderMarketType];
    if (!mapping) {
        return undefined;
    }

    return firstHalfStatTypes.has(statType)
        ? mapping.firstHalf
        : mapping.fullTime;
}

export interface BetBuilderMarketTypeInfo {
    betBuilderMarketType: BetBuilderMarket;
    statType: BetBuilderStatType.FirstHalf | BetBuilderStatType.FullTime;
}

export function marketTypeToBetBuilder(marketType: MarketType): BetBuilderMarketTypeInfo | undefined {
    const betBuilderMarketType = marketTypeToBetBuilderMarketTypeMapping[marketType];
    if (!betBuilderMarketType) {
        return undefined;
    }

    const statType = firstHalfMarketTypes.has(marketType)
        ? BetBuilderStatType.FirstHalf
        : BetBuilderStatType.FullTime;

    return { betBuilderMarketType, statType };
}
